.modal-body h4{line-height:2em}
/*# sourceMappingURL=deletemodal-NX5A3DX4.css.map */
